import AdultReviewsWorkspace from "../../../components/reviews/AdultReviewsWorkspace";

const AdultReviewsPage = () => {
  return <AdultReviewsWorkspace />;
};

export default AdultReviewsPage;
